import {
  HIVE_KEYBOARD_TOOLBAR_WIDGET,
  HiveKeyboardToolbarWidget,
} from './index.js';
import {
  HIVE_KEYBOARD_TOOL_PANEL,
  HiveKeyboardToolPanel,
} from './keyboard-tool-panel.js';
import {
  HIVE_KEYBOARD_TOOLBAR,
  HiveKeyboardToolbar,
} from './keyboard-toolbar.js';

export function effects() {
  customElements.define(
    HIVE_KEYBOARD_TOOLBAR_WIDGET,
    HiveKeyboardToolbarWidget
  );
  customElements.define(HIVE_KEYBOARD_TOOLBAR, HiveKeyboardToolbar);
  customElements.define(HIVE_KEYBOARD_TOOL_PANEL, HiveKeyboardToolPanel);
}

declare global {
  interface HTMLElementTagNameMap {
    [HIVE_KEYBOARD_TOOLBAR]: HiveKeyboardToolbar;
    [HIVE_KEYBOARD_TOOL_PANEL]: HiveKeyboardToolPanel;
  }
}
